export const employeesPerPage = 20;
